import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type { Uuid } from 'src/apis/api-utilities';
import type {
  HydrogenShipperBookingDetails,
  OptionalUrlTemplate,
  UrlTemplate,
} from 'src/apis/hydrogen-fcfs/types';
import { useAxios } from 'src/hooks/use-axios';

type HookParams = {
  bookingProcessId: Uuid;
} & OptionalUrlTemplate;

type RequestParams = {
  bookingProcessId: Uuid;
} & UrlTemplate;

export function useHydrogenShipperBookingDetails({
  url,
  bookingProcessId,
}: HookParams) {
  const request = useAxios(
    (axios, baseConfig, { url, bookingProcessId }: RequestParams) =>
      axios.request<HydrogenShipperBookingDetails>({
        ...baseConfig,
        url: urlTemplate.parse(url).expand({ bookingProcessId }),
      }),
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    if (!url) return;
    request.execute({ url, bookingProcessId });
    // oxlint-disable-next-line exhaustive-deps
  }, [url, bookingProcessId]);

  return request;
}

export type HydrogenShipperBookingDetailsRequest = ReturnType<
  typeof useHydrogenShipperBookingDetails
>;
